var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bookitem"},[_c('div',{staticClass:"border"},[_c('div',{staticClass:"f18"},[_c('nobr',[_vm._v(_vm._s(_vm.books.bookName))])],1),_c('div',{staticClass:"f17"},[_vm._v(_vm._s(_vm.books.slogan)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }